// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"36712265","132":"3c9d0dad","139":"b33a54df","898":"1b0f2828"}[chunkId] + ".chunk.css";
};